export const sizes = Object.freeze({
  xs: '1-10',
  s: '11-100',
  m: '101-500',
  l: '500+',
  MICRO: '1-10',
  SMALL: '11-100',
  MEDIUM: '101-500',
  LARGE: '500+',
});

export default Object.freeze({
  MICRO: `constants.companySizeMicro`, // `Mikroföretag (${sizes.xs})`,
  SMALL: `constants.companySizeSmall`, // `Småföretag (${sizes.s})`,
  MEDIUM: `constants.companySizeMedium`, // `Medelstora företag (${sizes.m})`,
  LARGE: `constants.companySizeLarge`, // `Stora företag (${sizes.l})`,
  MICRO_SPAN: 'constants.companySizeMicroSpan', // `Mikroföretag <span>(${sizes.xs})</span>`,
  SMALL_SPAN: 'constants.companySizeSmallSpan', // `Småföretag <span>(${sizes.s})</span>`,
  MEDIUM_SPAN: 'constants.companySizeMediumSpan', // `Medelstora företag <span>(${sizes.m})</span>`,
  LARGE_SPAN: 'constants.companySizeLargeSpan', // `Stora företag <span>(${sizes.l})</span>`,
  MICRO_SHORT: 'constants.companySizeMicroShort', // 'Mikroföretag',
  SMALL_SHORT: 'constants.companySizeSmallShort', // 'Småföretag',
  MEDIUM_SHORT: 'constants.companySizeMediumShort', // 'Medelstora företag',
  LARGE_SHORT: 'constants.companySizeLargeShort', // 'Stora företag',
  MICRO_SHORT_SINGULAR: 'constants.companySizeMicroShortSingular', // 'Mikroföretag',
  SMALL_SHORT_SINGULAR: 'constants.companySizeSmallShortSingular', // 'Litet företag',
  MEDIUM_SHORT_SINGULAR: 'constants.companySizeMediumShortSingular', // 'Medelstort företag',
  LARGE_SHORT_SINGULAR: 'constants.companySizeLargeShortSingular', // 'Stort företag',
  MICRO_SPAN_SINGULAR: 'constants.companySizeMicroSpanSingular', // `Mikroföretag <span>(${sizes.xs})</span>`,
  SMALL_SPAN_SINGULAR: 'constants.companySizeSmallSpanSingular', // `Litet företag <span>(${sizes.s})</span>`,
  MEDIUM_SPAN_SINGULAR: 'constants.companySizeMediumSpanSingular', // `Medelstort företag <span>(${sizes.m})</span>`,
  LARGE_SPAN_SINGULAR: 'constants.companySizeLargeSpanSingular', // `Stort företag <span>(${sizes.l})</span>`,
});
